import { render, staticRenderFns } from "./TemplateSort.vue?vue&type=template&id=6bc7477f&scoped=true&"
import script from "./TemplateSort.vue?vue&type=script&lang=ts&"
export * from "./TemplateSort.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSort.vue?vue&type=style&index=0&id=6bc7477f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7477f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VContainer,VTooltip})
